import { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/Auth";
import Spinner from "../Spinner";

const AdminRoute = () => {
  const [ok, setOk] = useState(false);
  const [auth] = useAuth();

  useEffect(() => {
    const checkAdminAuth = async () => {
      try {
        const res = await axios.get(
          "https://portfoliomern-mxue.onrender.com/api/v1/auth/admin-auth",
          {
            headers: { Authorization: `Bearer ${auth?.token}` },
          }
        );
        setOk(res.data.ok); // Admin authorized
      } catch (error) {
        console.error("Admin authorization failed:", error.response?.data);
        setOk(false); // Admin not authorized
      }
    };

    if (auth?.token) checkAdminAuth();
  }, [auth?.token]);

  return ok ? (
    <Outlet /> // Render child components if authorized
  ) : auth?.token ? (
    <Spinner path="" /> // Show spinner while verifying
  ) : (
    <Navigate to="/login" /> // Redirect to login if not authenticated
  );
};

export default AdminRoute;
